/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CategoryIEnumerableResponse } from '../models';
import { LeaveTypeIEnumerableResponse } from '../models';
import { LetterTemplateIEnumerableResponse } from '../models';
import { SolelyJointlyIEnumerableResponse } from '../models';
import { TimeEntryActivityIEnumerableResponse } from '../models';
import { TimeEntryTypeIEnumerableResponse } from '../models';
/**
 * CodeApi - axios parameter creator
 * @export
 */
export const CodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCategoriesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLeaveTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetLeaveTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns LetterTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLetterTemplatesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetLetterTemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns SolelyJointlies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSolelyJointliesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetSolelyJointlies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TimeEntryActivities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryActivitiesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimeEntryActivities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TimeEntryTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimeEntryTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeApi - functional programming interface
 * @export
 */
export const CodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetCategoriesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetCategoriesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetLeaveTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetLeaveTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns LetterTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetLetterTemplatesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LetterTemplateIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetLetterTemplatesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns SolelyJointlies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetSolelyJointliesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolelyJointlyIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetSolelyJointliesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TimeEntryActivities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimeEntryActivitiesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryActivityIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimeEntryActivitiesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TimeEntryTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimeEntryTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimeEntryTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CodeApi - factory interface
 * @export
 */
export const CodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCategoriesGet(options?: any): AxiosPromise<CategoryIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns LeaveTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLeaveTypesGet(options?: any): AxiosPromise<LeaveTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetLeaveTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns LetterTemplates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLetterTemplatesGet(options?: any): AxiosPromise<LetterTemplateIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetLetterTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns SolelyJointlies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSolelyJointliesGet(options?: any): AxiosPromise<SolelyJointlyIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetSolelyJointliesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TimeEntryActivities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryActivitiesGet(options?: any): AxiosPromise<TimeEntryActivityIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimeEntryActivitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TimeEntryTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryTypesGet(options?: any): AxiosPromise<TimeEntryTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimeEntryTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeApi - object-oriented interface
 * @export
 * @class CodeApi
 * @extends {BaseAPI}
 */
export class CodeApi extends BaseAPI {
    /**
     * 
     * @summary Returns Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetCategoriesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns LeaveTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetLeaveTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetLeaveTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns LetterTemplates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetLetterTemplatesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetLetterTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns SolelyJointlies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetSolelyJointliesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetSolelyJointliesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TimeEntryActivities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimeEntryActivitiesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimeEntryActivitiesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TimeEntryTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimeEntryTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimeEntryTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
